import slugify from './slugify';


export const findSectionForPath = (pathname, sections) => {
    let activeSection;

    const source = pathname.slice(0, pathname.length - 1);
    const pageId = "/" + source.split('/').slice(source.split('/').length - 2).join("/") + "/";

    sections.forEach(section => {
        const match = section.items && section.items.some(
            item =>
                pageId === slugify(item.id, section.id)
        );
        if (match) {
            activeSection = section;
        }
    });

    return activeSection;
};
